import Icon from "@ant-design/icons"
import { ReactComponent as ChevronDownIcon } from "./chevron-down.svg"

const ChevronDown = (props: any) => (
  <Icon style={{ fontSize: "10px" }} component={ChevronDownIcon} {...props} />
)

export default ChevronDown
